export const APPLICATION_MODE = {
  PENDING_REVIEW: 'PENDING_REVIEW',
  IN_PROGRESS: 'IN_PROGRESS',
};

export const PUBLIC_ROUTES = [
  'welcome',
  'next-steps',
  'agent-register',
];

export const CREDENTIALS_STATUS = {
  INFO: 'info',
  SUCCESS: 'success',
};

export const CREDENTIALS_DOC_TYPE = {
  LICENSE: 'LICENSE',
  W9: 'W9',
  APPRAISER_PHOTO: 'APPRAISER_PHOTO',
};

export const MAX_CREDENTIALS_LICENSE_COUNT = 3;

export const SECONDS_IN_A_DAY = 60 * 60 * 24;

export const PROFILE_STEP_TYPES = {
  WELCOME: 'WELCOME',
  USER_PROFILE: 'USER_PROFILE',
  COMPANY_PROFILE: 'COMPANY_PROFILE',
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  LOCAL_MARKET: 'LOCAL_MARKET',
  FEES: 'FEES',
  COVERAGE: 'COVERAGE',
  PROFESSIONAL: 'PROFESSIONAL',
  CREDENTIALS: 'CREDENTIALS',
  E_AND_O: 'E_AND_O',
  BACKGROUND: 'BACKGROUND',
  COMPLETION: 'COMPLETION',
};

export const US_STATES = [
  {
    name: 'AK',
    value: 'AK',
  },
  {
    name: 'AL',
    value: 'AL',
  },
  {
    name: 'AR',
    value: 'AR',
  },
  {
    name: 'AZ',
    value: 'AZ',
  },
  {
    name: 'CA',
    value: 'CA',
  },
  {
    name: 'CO',
    value: 'CO',
  },
  {
    name: 'CT',
    value: 'CT',
  },
  {
    name: 'DE',
    value: 'DE',
  },
  {
    name: 'FL',
    value: 'FL',
  },
  {
    name: 'GA',
    value: 'GA',
  },
  {
    name: 'HI',
    value: 'HI',
  },
  {
    name: 'IA',
    value: 'IA',
  },
  {
    name: 'ID',
    value: 'ID',
  },
  {
    name: 'IL',
    value: 'IL',
  },
  {
    name: 'IN',
    value: 'IN',
  },
  {
    name: 'KS',
    value: 'KS',
  },
  {
    name: 'KY',
    value: 'KY',
  },
  {
    name: 'LA',
    value: 'LA',
  },
  {
    name: 'MA',
    value: 'MA',
  },
  {
    name: 'MD',
    value: 'MD',
  },
  {
    name: 'ME',
    value: 'ME',
  },
  {
    name: 'MI',
    value: 'MI',
  },
  {
    name: 'MN',
    value: 'MN',
  },
  {
    name: 'MO',
    value: 'MO',
  },
  {
    name: 'MS',
    value: 'MS',
  },
  {
    name: 'MT',
    value: 'MT',
  },
  {
    name: 'NC',
    value: 'NC',
  },
  {
    name: 'ND',
    value: 'ND',
  },
  {
    name: 'NE',
    value: 'NE',
  },
  {
    name: 'NH',
    value: 'NH',
  },
  {
    name: 'NJ',
    value: 'NJ',
  },
  {
    name: 'NM',
    value: 'NM',
  },
  {
    name: 'NV',
    value: 'NV',
  },
  {
    name: 'NY',
    value: 'NY',
  },
  {
    name: 'OH',
    value: 'OH',
  },
  {
    name: 'OK',
    value: 'OK',
  },
  {
    name: 'OR',
    value: 'OR',
  },
  {
    name: 'PA',
    value: 'PA',
  },
  {
    name: 'RI',
    value: 'RI',
  },
  {
    name: 'SC',
    value: 'SC',
  },
  {
    name: 'SD',
    value: 'SD',
  },
  {
    name: 'TN',
    value: 'TN',
  },
  {
    name: 'TX',
    value: 'TX',
  },
  {
    name: 'UT',
    value: 'UT',
  },
  {
    name: 'VA',
    value: 'VA',
  },
  {
    name: 'VT',
    value: 'VT',
  },
  {
    name: 'WA',
    value: 'WA',
  },
  {
    name: 'WI',
    value: 'WI',
  },
  {
    name: 'WV',
    value: 'WV',
  },
  {
    name: 'WY',
    value: 'WY',
  },
];

